import tpvPreview from '@assets/images/tpv-hero.webp';
import { Link } from 'react-router-dom';
import { ContactFormSection } from '../../components/marketing/ContactFormSection';
import { SunmiTerminalSection } from '../../components/marketing/SunmiTerminalSection';
import { SupportServiceIcon } from '../../components/marketing/SupportServiceIcon';
import {
  formatSupportRate,
  getSupportServiceRate,
  standardSupportServices,
  SUPPORT_BUSINESS_HOURS,
  SUPPORT_CLIENT_RATES,
  urgentSupportService,
} from '../../config/support-pricing';
import { useAuth } from '../../context/AuthContext';
import { usePricing } from '../../hooks/usePricing';

export function ContactPage() {
  const { isAuthenticated } = useAuth();
  const pricing = usePricing();

  return (
    <>
      <section className="hero">
        <div className="container hero__grid contact-hero__grid">
          <div className="contact-hero__copy">
            <h1>Ponemos Hosty en marcha contigo.</h1>
            <p className="hero__lead">
              Instalación remota o presencial y formación para tu equipo, siempre con presupuesto
              previo y separadas de la cuota del software.
            </p>
          </div>
          <div className="contact-hero__media">
            <img src={tpvPreview} alt="TPV Hosty mostrando la pantalla de venta" width={900} height={900} />
          </div>
        </div>
      </section>

      <ContactFormSection />
      <SunmiTerminalSection />

      <section className="section" style={{ paddingTop: '3rem' }}>
        <div className="container">
          <div className="section__header">
            <h2>Servicios de soporte técnico</h2>
            <p className="muted">
              La corrección de errores de Hosty no se cobra. Para configuración, formación o una
              intervención técnica recibirás un presupuesto antes de empezar.
            </p>
          </div>

          <div className="ui-card" style={{ padding: '1.25rem 1.5rem', marginBottom: '1.5rem' }}>
            <div className="stack" style={{
              flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center',
              justifyContent: 'space-between', gap: '1rem',
            }}>
              <div>
                <strong>{isAuthenticated ? 'Solicita soporte técnico' : '¿Ya eres cliente?'}</strong>
                <p className="muted" style={{ margin: '0.35rem 0 0', fontSize: '0.9rem' }}>
                  {formatSupportRate(SUPPORT_CLIENT_RATES.standard)} estándar ·{' '}
                  {getSupportServiceRate('urgent')} urgente · IVA incluido
                </p>
              </div>
              {isAuthenticated ? (
                <Link to="/panel/soporte" className="ui-btn ui-btn--primary">Solicitar soporte</Link>
              ) : (
                <Link to="/login?redirect=%2Fpanel%2Fsoporte" className="ui-btn ui-btn--primary">
                  Iniciar sesión y solicitar soporte
                </Link>
              )}
            </div>
          </div>

          <div className="grid-2" style={{ gap: '1.25rem' }}>
            <article className="feature-card">
              <div className="support-pack__card-icon"><SupportServiceIcon id="standard" size="card" /></div>
              <p className="support-pack__rate">{formatSupportRate(SUPPORT_CLIENT_RATES.standard)}</p>
              <p className="muted" style={{ margin: '-0.3rem 0 0.4rem', fontSize: '0.8rem' }}>IVA incluido</p>
              <h3 style={{ margin: '0 0 0.4rem' }}>Soporte estándar</h3>
              <p className="muted" style={{ margin: '0 0 1rem', fontSize: '0.9rem' }}>
                Tarifa por hora en horario laboral ({SUPPORT_BUSINESS_HOURS}) para configuración,
                formación y asistencia remota.
              </p>
              <ul className="support-pack__list">
                {standardSupportServices.map((service) => (
                  <li className="support-pack__item" key={service.name}>
                    <span className="support-pack__item-icon" aria-hidden="true">
                      <SupportServiceIcon id={service.icon} size="item" />
                    </span>
                    <div>
                      <strong className="support-pack__item-title">{service.name}</strong>
                      <span className="muted support-pack__item-desc">{service.description}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </article>

            <article className="feature-card">
              <div className="support-pack__card-icon">
                <SupportServiceIcon id={urgentSupportService.icon} size="card" />
              </div>
              <p className="support-pack__rate support-pack__rate--urgent">
                {getSupportServiceRate('urgent')}
              </p>
              <p className="muted" style={{ margin: '-0.3rem 0 0.4rem', fontSize: '0.8rem' }}>IVA incluido</p>
              <h3 style={{ margin: '0 0 0.4rem' }}>{urgentSupportService.name}</h3>
              <p className="muted" style={{ margin: 0, fontSize: '0.9rem' }}>
                {urgentSupportService.description}
              </p>
            </article>
          </div>

          <p className="muted" style={{ marginTop: '1.5rem', fontSize: '0.85rem' }}>
            La licencia del TPV ({pricing.formatted}, IVA incluido) se contrata por separado en{' '}
            <Link to="/precios">precios</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
